module.exports = __webpack_public_path__ + "img/earth-light-medium.4d377ed1.svg";